module.exports = __webpack_public_path__ + "static/media/rps2.6d2ab3e6.png";